@if (loading) {
  <div
    class="spot-modal"
  ></div>
}
@if (!loading && step === Steps.ProjectSelection) {
  <op-ium-project-selection [project]="project"
    [type]="type"
    (save)="onProjectSelectionSave($event)"
    (close)="closeMe()"
    tabindex="0"
    cdkFocusInitial
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
   />
}

@if (!loading && step === Steps.Principal) {
  <op-ium-principal [project]="project"
    [roleData]="role"
    [messageData]="message"
    [principalData]="principalData"
    [type]="type"
    (save)="onPrincipalSave($event)"
    (back)="goTo(Steps.ProjectSelection)"
    (close)="closeMe()"
    tabindex="0"
    cdkFocusInitial
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
   />
}

@if (!loading && step === Steps.Summary) {
  <op-ium-summary [project]="project"
    [principalData]="principalData"
    [type]="type"
    [role]="role"
    [message]="message"
    (save)="onSuccessfulSubmission($event)"
    (back)="goTo(Steps.Principal)"
    (close)="closeMe()"
    tabindex="0"
    cdkFocusInitial
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
   />
}

@if (!loading && step === Steps.Success) {
  <op-ium-success [principal]="principalData.principal"
    [project]="project"
    [type]="type"
    [createdNewPrincipal]="createdNewPrincipal"
    class="spot-modal"
    (close)="closeWithPrincipal()"
    tabindex="0"
    cdkFocusInitial
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
   />
}
